import './style.css';
import { App } from './ui/app';

const root = document.getElementById('app');
if (!root) {
  throw new Error('#app 要素が見つかりません。index.html を確認してください。');
}

new App(root);
